import type { Page } from '@/domain/model/Page';
import type { MetodoAvaliativo, UpsertMetodoAvaliativoCommand } from '@/domain/model/MetodoAvaliativo';
import type { MetodoAvaliativoGateway, ListMetodosParams } from '@/application/port/out/MetodoAvaliativoGateway';
import type {
  ListMetodosAvaliativosUseCase, CreateMetodoAvaliativoUseCase,
  UpdateMetodoAvaliativoUseCase, DeleteMetodoAvaliativoUseCase,
} from '@/application/port/in/MetodoAvaliativoUseCase';

export class ListMetodosAvaliativos implements ListMetodosAvaliativosUseCase {
  constructor(private readonly g: MetodoAvaliativoGateway) {}
  execute(params: ListMetodosParams): Promise<Page<MetodoAvaliativo>> { return this.g.list(params); }
}
export class CreateMetodoAvaliativo implements CreateMetodoAvaliativoUseCase {
  constructor(private readonly g: MetodoAvaliativoGateway) {}
  execute(cmd: UpsertMetodoAvaliativoCommand): Promise<MetodoAvaliativo> { return this.g.create(cmd); }
}
export class UpdateMetodoAvaliativo implements UpdateMetodoAvaliativoUseCase {
  constructor(private readonly g: MetodoAvaliativoGateway) {}
  execute(id: string, cmd: UpsertMetodoAvaliativoCommand): Promise<MetodoAvaliativo> { return this.g.update(id, cmd); }
}
export class DeleteMetodoAvaliativo implements DeleteMetodoAvaliativoUseCase {
  constructor(private readonly g: MetodoAvaliativoGateway) {}
  execute(id: string): Promise<void> { return this.g.remove(id); }
}
